module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_26.1ce3c2b4.pdf";